// Vite replaces `import.meta.env.X` at build time. Isolating the read
// here lets Jest mock this module via `jest.mock('@/lib/api-base')` so
// the rest of the api-client compiles under the CommonJS test runner
// (which can't parse `import.meta`).
export const API_BASE_URL: string =
  (import.meta.env['VITE_API_URL'] as string | undefined) ?? '/api';
